export default __webpack_public_path__ + "static/media/postgresql.41d30ac9.png";